// @ts-strict-ignore
import getColumnOptions from '@/hybrid/tableBuilder/tableViewer/chartConfigs/column';

const getColumnStackedOptions = (tableData, settings) => getColumnOptions(tableData, { ...settings, stacked: true });
export default getColumnStackedOptions;
